import React, { useState} from 'react';
import Alert from './Alert';
function ChangeDetails(props) {
    const[assetId,setAssetId]=useState("");
    const [newDetail, setNewDetail] = useState("");
    const [option, setOption] = useState(1)
    let value,id,opt;
    const handleAssetId=(e)=>{
        value=e.target.value;
        setAssetId(value);
    }
    const handlenewDetail=(e)=>{
        value=e.target.value;
        setNewDetail(value);
    }
    const handleOption=(e)=>{
        value=e.target.value;
        value=parseInt(value);
        setOption(value);
    }
    const updateAsset= async (e)=>{
        props.setProgress(10);
        e.preventDefault();
        const accounts = await window.ethereum.enable();
        const account = accounts[0];
        opt=option;
        value=newDetail;
        id=assetId;
        setNewDetail("");
        setAssetId("");
        props.setProgress(100);
        if(opt===1){
            try{
                const result = await props.SimpleContract.methods.changeAssetName(id,value).send({
                    from: account
                });
            }
            catch(err){
                console.log(err);
            }
        }
        else if(opt===2){
            try{
                const result = await props.SimpleContract.methods.changeAssetCondition(id,value).send({
                    from: account
                });
            }
            catch(err){
                console.log(err);
            }
        }
        else if(opt===3){
            try{
                value=parseInt(value);
                const result = await props.SimpleContract.methods.changeAssetGrade(id,value).send({
                    from: account
                });
            }
            catch(err){
                console.log(err);
            }
        }
        else if(opt===4){
            try{
                const result = await props.SimpleContract.methods.changeAssetManufacturingYear(id,value).send({
                    from: account
                });
            }
            catch(err){
                console.log(err);
            }
        }
        else if(opt===5){
            try{
                const result = await props.SimpleContract.methods.changeAssetManufacturer(id,value).send({
                    from: account
                });
            }
            catch(err){
                console.log(err);
            }
        }
        else if(opt===6){
            try{
                const result = await props.SimpleContract.methods.changeAssetSet(id,value).send({
                    from: account
                });
            }
            catch(err){
                console.log(err);
            }
        }
        else if(opt===7){
            try{
                const result = await props.SimpleContract.methods.changeCardNumber(id,value).send({
                    from: account
                });
            }
            catch(err){
                console.log(err);
            }
        }
        else if(opt===8){
            try{
                const result = await props.SimpleContract.methods.changeAssetDetails(id,value).send({
                    from: account
                });
            }
            catch(err){
                console.log(err);
            }
        }

    }
    const isMetaMaskInstall=()=>{
        if(props.SimpleContract===undefined){
            const  obj={
                type:"warning",
                message:"Please Install MetaMask and Refresh the Page and only egs is authorized to change asset details."
            }
            return(
                <Alert alert={obj}/>
            )
        }
        else{
            const  obj={
                type:"warning",
                message:"Only egs is authorized to change asset details."
            }
            return(
                <Alert alert={obj}/>
            )
        }
    }
    return (
        <>
        {isMetaMaskInstall()}
        <div className="forcenter">
        <div className="fordetail">
            <form className="container mt-4">
                <div className="form-floating mb-4">
                    <input type="text" className="form-control" id="_assetId" name="_assetId" value={assetId}  placeholder="assetId" onChange={handleAssetId}/>
                    <label htmlFor="floatingInput">Enter Asset Id</label>
                </div>
                <div className="form-floating mb-4">
                    <input type="text" className="form-control" id="_newDetail" name="_newDetail" value={newDetail}  placeholder="newDetail" onChange={handlenewDetail}/>
                    <label htmlFor="floatingInput">Enter Detail</label>
                </div>
                <select className="form-select mb-5" aria-label="Default select example" onChange={handleOption}>
                    <option value="1">Name</option>
                    <option value="2">Condition</option>
                    <option value="3">Grade</option>
                    <option value="4">Manufacturing Year</option>
                    <option value="5">Maunfacturer</option>
                    <option value="6">Set</option>
                    <option value="7">Card Number</option>
                    <option value="8">Asset Details</option>
                </select>
                <button type="submit" className="btn btn-primary" disabled={!(assetId!=="" && newDetail!=="")} onClick={updateAsset}>Change Details</button>
            </form> 
            </div>
            </div>
        </>
    )
}

export default ChangeDetails
